module.exports = __webpack_public_path__ + "static/q19-a0f9093b32fc199cfef1a24f2212183a.png";